/**
 * Get the Vue instance set up
 */
import Vue from 'vue';

'use strict';

window.$ = jQuery;
window.Vue = Vue;

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

// Polyfills - add as needed
require('./polyfills/foreach.js');

if (document.getElementById('vue')) {
	/**
	 * Promise Polyfill for Old IE
	 */
	require('es6-promise').polyfill();
	require('fetch-ie8');
	require('array-from');

	//Include components
	Vue.component('ServiceFinder', require('./vue/components/layouts/ServiceFinder.vue').default);
	Vue.component('ServiceFinderForm', require('./vue/components/forms/ServiceFinderForm.vue').default);

	//Include mixins
	window.mixins = require('./vue/mixins');
	Vue.mixin(mixins);

	//Init vue
	const app = new Vue({
		el: '#vue',

		data() {
			return {}
		},

		mounted() {
			//
		},
	});
}
